import { schema } from "normalizr";
interface IRemarketingExportResponse {
    id: number;
    businessDataExportId: number;
    currency: string;
    fuelInventory: null | string;
    fuelInventoryId: null | number;
    facebookAutoRemarketingExportMappings: [];
    conditions: [] | null;
    ignoredImagesSizes: null;
    ignoredImages: string[];
    inventorySource: string;
    mileageUnit: string;
    name: string;
    updatedAt: string;
    createdAt: string;
}
interface IRemarketingExportResponseMapped {
    id: number;
    businessDataExportId: number;
    currency: string;
    fuelInventory: null | string;
    fuelInventoryId: null | number;
    facebookAutoExports: [];
    conditions: [] | null;
    ignoredImagesSizes: null;
    ignoredImages: string[] | null;
    inventorySource: string;
    mileageUnit: string;
    name: string;
    updatedAt: string;
    createdAt: string;
}
const facebookAutoExport = new schema.Entity("facebookAutoExports");
const facebookAutoExportLog = new schema.Entity("facebookAutoExportLogs");

const remarketingInventoryExport = new schema.Entity(
    "remarketingInventoryExports",
    {
        facebookAutoExports: [facebookAutoExport]
    },
    {
        processStrategy: ({
            id,
            businessDataExportId,
            currency,
            fuelInventory,
            fuelInventoryId,
            facebookAutoRemarketingExportMappings,
            conditions,
            ignoredImagesSizes,
            ignoredImages,
            inventorySource,
            mileageUnit,
            name,
            updatedAt,
            createdAt
        }: IRemarketingExportResponse): IRemarketingExportResponseMapped => {
            return {
                id,
                businessDataExportId,
                currency,
                fuelInventory,
                fuelInventoryId,
                ignoredImagesSizes,
                inventorySource,
                mileageUnit,
                name,
                updatedAt,
                createdAt,
                ignoredImages,
                conditions,
                facebookAutoExports: facebookAutoRemarketingExportMappings
            };
        }
    }
);

const Schemas = {
    REMARKETING_INVENTORY_EXPORT_ARRAY: { data: [remarketingInventoryExport] },
    REMARKETING_INVENTORY_EXPORT: remarketingInventoryExport,
    FACEBOOK_AUTO_EXPORT_ARRAY: { data: [facebookAutoExport] },
    FACEBOOK_AUTO_EXPORT: facebookAutoExport,
    FACEBOOK_AUTO_EXPORT_LOG_ARRAY: { data: [facebookAutoExportLog] },
    FACEBOOK_AUTO_EXPORT_LOG: facebookAutoExportLog
};

export default Schemas;
